exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.replyItemWrap {\n  padding: 8px 0;\n  border-bottom: 1px solid transparent;\n}\n.replyItemWrap:last-child {\n  border-bottom: 0;\n}\n.replyItemWrap .replyItemName {\n  font-size: 12px;\n  line-height: 20px;\n}\n.replyItemWrap .replyItemCont {\n  line-height: 20px;\n  font-size: 14px;\n  margin-top: 10px;\n  padding-left: 16px;\n}\n", ""]);

// exports
